import { createStyles, withStyles } from '@material-ui/core/styles';
import BaseTab from '@material-ui/core/Tab';
import BaseTabs from '@material-ui/core/Tabs';
import palette from 'theme/palette';

export const Tabs = withStyles({
  root: {
    borderBottom: '1px solid #e8e8e8',
    marginTop: 24,
  },
  indicator: {
    backgroundColor: palette.pink,
  },
})(BaseTabs);

export const Tab = withStyles({
  root: {
    padding: '0 16px',
    fontSize: 14,
    fontWeight: 500,
    opacity: 1,
    color: palette.gray,
    minHeight: 35,

    '&:hover': {
      background: palette.lightGray,
      textDecoration: 'none',
    },

    '& .MuiBadge-badge': {
      paddingTop: 1,
      height: 12,
      fontSize: 10,
      fontWeight: 500,
    },
  },
  selected: {
    color: palette.pink,
  },
  disabled: {
    fontWeight: 400,
    opacity: 0.3,
  },
})(BaseTab);

export default () =>
  createStyles({
    tabs: {
      '& .MuiTabs-fixed': {
        height: 35,
      },
      '& .MuiTabs-flexContainer': {
        height: 35,
      },
      '& .MuiTabs-root': {
        minHeight: 35,
      },
    },
    tab: {
      fontSize: 14,
      fontWeight: 500,
      minHeight: 35,
      alignItems: 'center',

      '&:hover': {
        textDecoration: 'none',
      },

      '& .MuiTab-wrapper': {
        flexDirection: 'row',
        alignItems: 'none',
      },
    },
    tabYellow: {
      '&.Mui-selected': {
        color: palette.navCompanyContextActions,
      },
    },
    tabGreen: {
      '&.Mui-selected': {
        color: palette.navAdminActions,
      },
    },

    tabGray: {
      '&.Mui-selected': {
        color: palette.navSuperAdminActions,
      },
    },
    tabBlue: {
      '&.Mui-selected': {
        color: palette.navOperatorActions,
      },
    },

    tabsYellow: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navCompanyContextActions,
      },
    },
    tabsGreen: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navAdminActions,
      },
    },
    tabsGray: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navSuperAdminActions,
      },
    },
    tabsBlue: {
      minHeight: 40,
      '& .MuiTabs-indicator': {
        background: palette.navOperatorActions,
      },
    },
    badge: {
      '& .MuiBadge-badge': {
        backgroundColor: palette.green,
        color: palette.white,
      },
    },
  });
